import { Router } from '@angular/router';
import { AiService } from './../service/ai.service';
import { AfterViewInit, Component, inject } from '@angular/core';

@Component({
  selector: 'app-home',
  standalone: false,

  templateUrl: './home.component.html',
  styleUrl: './home.component.scss'
})
export class HomeComponent implements AfterViewInit {

  constructor(
    private router: Router,
  ) { }

  ngAfterViewInit(): void {
    let redirect = localStorage.getItem('ids_redirect');
    if (redirect) {
      localStorage.removeItem('ids_redirect');
      this.router.navigate([redirect]);
    }
  }
}
